import { CIcon } from '~/icons/types'

export const ciConstructionYear: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M10.363 18.753a.88.88 0 0 0 .63.255c.14-.001.28-.03.411-.082l7.368-2.888a2.025 2.025 0 0 0 .744-3.435l-.764-.77.571-.508a1.191 1.191 0 0 0 .108-1.667L18.2 8.222a2.11 2.11 0 0 0 .5-.322l3.37-3.08a2.064 2.064 0 0 0 .13-2.866 2.043 2.043 0 0 0-2.882-.2L15.975 4.81a2.073 2.073 0 0 0-.2 2.91c.012.013.027.023.039.036l2.286 2.65-.4.36-1.18-1.188a2.014 2.014 0 0 0-3.453.67l-2.875 7.459a.947.947 0 0 0 .171 1.045Zm6.614-12.826 3.329-3.05a.544.544 0 0 1 .765.064.572.572 0 0 1-.028.78L17.69 6.785a.512.512 0 0 1-.4.138.536.536 0 0 1-.361-.173c-.005-.006-.012-.008-.017-.013a.568.568 0 0 1 .063-.81h.002Zm-2.51 4.845.014-.043a.521.521 0 0 1 .493-.365.58.58 0 0 1 .438.228l1.164 1.172-1.184 1.053a.75.75 0 1 0 1 1.12l1.247-1.108.87.876a.53.53 0 0 1-.225.919l-6.236 2.443 2.419-6.295Z'
    },
    {
      d:
        'M22 16.868h-3a.75.75 0 1 0 0 1.5h2.25v2.882h-4.587V19a.75.75 0 1 0-1.5 0v2.25H8.75v-3.632a.75.75 0 0 0-.75-.75H5.75v-2.852H9a.75.75 0 1 0 0-1.5h-.25v-2.5H11a.75.75 0 1 0 0-1.5h-.25v-4.25a.75.75 0 0 0-.75-.75H2a.75.75 0 0 0-.75.75V22a.75.75 0 0 0 .75.75h20a.75.75 0 0 0 .75-.75v-4.382a.75.75 0 0 0-.75-.75Zm-17.75 0h-1.5v-2.852h1.5v2.852Zm3-4.352h-4.5v-2.5h4.5v2.5Zm2-4H6.229v-3.5H9.25v3.5Zm-4.521-3.5v3.5H2.75v-3.5h1.979ZM7.25 21.25h-4.5v-2.882h4.5v2.882Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'construction-year',
  type: 'light'
}
